import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { MuscleGroupVolume, getMuscleGroupColor } from "@/lib/volume-balance";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface MuscleGroupTableProps {
  muscleGroups: MuscleGroupVolume[];
}

export function MuscleGroupTable({ muscleGroups }: MuscleGroupTableProps) {
  if (muscleGroups.length === 0) {
    return null;
  }

  const maxSets = Math.max(...muscleGroups.map((mg) => mg.sets));

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Volume Breakdown</CardTitle>
        <CardDescription>Sets per muscle group</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {muscleGroups.slice(0, 12).map((mg) => (
            <div key={mg.muscleGroup} className="space-y-1">
              <div className="flex items-center justify-between text-sm">
                <Tooltip>
                  <TooltipTrigger asChild>
                    <span className="font-medium capitalize cursor-help">
                      {mg.muscleGroup}
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>
                    <div className="text-xs">
                      <p className="font-medium mb-1">Exercises used:</p>
                      <ul className="list-disc list-inside">
                        {mg.exercises.slice(0, 5).map((ex) => (
                          <li key={ex}>{ex}</li>
                        ))}
                        {mg.exercises.length > 5 && (
                          <li>+{mg.exercises.length - 5} more</li>
                        )}
                      </ul>
                    </div>
                  </TooltipContent>
                </Tooltip>
                <span className="text-muted-foreground">
                  {mg.sets} sets ({mg.percentage.toFixed(1)}%)
                </span>
              </div>
              <div className="relative">
                <Progress 
                  value={(mg.sets / maxSets) * 100} 
                  className="h-2"
                  style={{
                    // @ts-ignore - CSS custom property
                    "--progress-background": getMuscleGroupColor(mg.muscleGroup),
                  } as React.CSSProperties}
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
